'use strict';
export default ($state, $stateParams, auth, joinForm) => {
  'ngInject';

  auth.activateAccount($stateParams)
    .then(function () {
      if ($stateParams.redirectUrl) {
        window.location.href = $stateParams.redirectUrl;
      }
      else {
        $state.go('intro');
      }
    })
    .catch((response) => {
      if (response.data.error === 'invalid-request') {
        $state.go('guides.list');
        joinForm();
      }
    });
};



// WEBPACK FOOTER //
// ./app/src/modules/activation/activation.controller.js